import useI18n from '@/hooks/useI18n';
import React from 'react';

interface CustomRadioButtonProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  value: string;
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string | null | undefined;
  className?: string;
  textStyle?: string;
}

const CustomRadioButton: React.FC<CustomRadioButtonProps> = ({
  name,
  value,
  checked,
  onChange,
  label,
  className,
  textStyle,
  ...props
}) => {
  const { t } = useI18n();
  return (
    <label className="flex items-center cursor-pointer">
      <div className="relative flex items-center">
        <input
          {...props}
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          className={`appearance-none w-[18px] h-[18px] border-2  rounded-full relative mr-2 capitalize  ${checked ? 'bg-[#172B4D] border-[#172B4D] ' : 'border-[#B3B3B2] hover:bg-gray-100'} ${className ? className : ''}`}
        />
        {checked && (
          <img
            src="/assets/whiteCheck.svg"
            alt="Checkmark"
            className="absolute top-1/2 left-[9px] transform -translate-x-1/2 -translate-y-1/2 w-[10px] h-[10px]"
          />
        )}
      </div>
      {label && (
        <span
          className={`text-[#020D3A] text-base ${textStyle ? textStyle : ''}`}
        >
          {label}
        </span>
      )}
    </label>
  );
};

export default CustomRadioButton;
